export default {
	methods: {
		hexToRgb(hex) {
			// Use rgb colors to use with rgba()
			let result =
				/^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex) ||
				/^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
			return result
				? result[4]
					? [
							parseInt(result[1], 16),
							parseInt(result[2], 16),
							parseInt(result[3], 16),
							parseInt(result[4], 16)
					  ]
					: [parseInt(result[1], 16), parseInt(result[2], 16), parseInt(result[3], 16)]
				: null;
		},

		rgbToHsl(rgb) {
			if (rgb === null) return;
			// Use css HSL colors to create different shades of one color. To use, first convert hex to rgb.
			const r = rgb[0] / 255;
			const g = rgb[1] / 255;
			const b = rgb[2] / 255;
			const a = rgb[3] ? Math.floor((rgb[3] / 255) * 100) / 100 : 1;
			const max = Math.max(r, g, b),
				min = Math.min(r, g, b);
			let h,
				s,
				l = (max + min) / 2;

			if (max == min) {
				h = s = 0; // achromatic
			} else {
				const d = max - min;

				s = l > 0.5 ? d / (2 - max - min) : d / (max + min);

				switch (max) {
					case r:
						h = (g - b) / d + (g < b ? 6 : 0);
						break;
					case g:
						h = (b - r) / d + 2;
						break;
					case b:
						h = (r - g) / d + 4;
						break;
				}

				h /= 6;
			}

			return [h, s, l, a];
		},

		invertHex(hex) {
			return '#' + ('000000' + (0xffffff ^ parseInt(hex.substring(1), 16)).toString(16)).slice(-6);
		},

		setCssVars(useGeneralColors = false) {
			const defaultPrimary = '#FD6402'; // orange
			const defaultContentBg = '#171722'; // dark-blue
			const defaultTextColor = '#ffffff';
			const defaultNavBarBgColor = '#0C0C10';
			const defaultWishlistColor = '#ff00ff';

			// Set default colors
			let rgbValuesPrimary = this.hexToRgb(defaultPrimary);

			let backgroundColor = defaultContentBg;
			let rgbValuesContentBg = this.hexToRgb(defaultContentBg);
			let hslValuesBg = this.rgbToHsl(rgbValuesContentBg);

			let backgroundColorOpaque = defaultContentBg;
			let rgbValuesContentBgOpaque = this.hexToRgb(defaultContentBg);
			let hslValuesBgOpaque = this.rgbToHsl(rgbValuesContentBg);

			let primaryTextColor = defaultTextColor;
			let rgbValuesText = this.hexToRgb(defaultTextColor);
			let hslValuesText = this.rgbToHsl(rgbValuesText);

			let navBarBgColor = this.hexToRgb(defaultNavBarBgColor);
			let navBarTextColor = defaultTextColor;

			let navBarButtonColor = defaultPrimary;
			let rgbNavBarButtonColor = this.hexToRgb(defaultPrimary);
			let hslNavBarButtonColor = this.rgbToHsl(rgbNavBarButtonColor);

			let navBarButtonTextColor = defaultContentBg;
			let rgbBarButtonTextColor = this.hexToRgb(navBarButtonTextColor);
			let hslBarButtonTextColor = this.rgbToHsl(rgbBarButtonTextColor);

			let buttonAlternativeBackgroundColor = defaultContentBg;
			let rgbButtonAlternativeBackgroundColor = this.hexToRgb(buttonAlternativeBackgroundColor);
			let hslButtonAlternativeBackgroundColor = this.rgbToHsl(rgbButtonAlternativeBackgroundColor);

			let buttonAlternativeTextColor = defaultTextColor;
			let rgbButtonAlternativeTextColor = this.hexToRgb(buttonAlternativeTextColor);
			let hslButtonAlternativeTextColor = this.rgbToHsl(rgbButtonAlternativeTextColor);

			let detailTextColor = defaultTextColor;
			let rgbDetailTextColor = this.hexToRgb(detailTextColor);
			let hslDetailTextColor = this.rgbToHsl(rgbDetailTextColor);

			let detailBackgroundColor = defaultContentBg;
			let rgbDetailBackgroundColor = this.hexToRgb(detailBackgroundColor);
			let hslDetailBackgroundColor = this.rgbToHsl(rgbDetailBackgroundColor);

			let cardBgColor = defaultContentBg;
			let navigationTopBarLinks = defaultTextColor;

			// Set default font
			document.documentElement.style.setProperty('--title-font', `'open_sans_semibold', sans-serif`);
			document.documentElement.style.setProperty('--title-transform', '');
			document.documentElement.style.setProperty('--font-bold', `'open_sans_semibold', sans-serif`);

			if (!useGeneralColors) {
				// Use shop specific colors from cms
				rgbValuesPrimary = this.hexToRgb(this.data?.primaryColor || defaultPrimary);

				backgroundColor = this.data?.backgroundColor || defaultContentBg;
				if (backgroundColor.length == 9) {
					backgroundColor = backgroundColor.split('').splice(0, 7).join('');
				}
				rgbValuesContentBg = this.hexToRgb(this.data?.backgroundColor || defaultContentBg);
				if (rgbValuesContentBg.length == 4) {
					rgbValuesContentBg.pop() || backgroundColor;
				}
				hslValuesBg = this.rgbToHsl(rgbValuesContentBg);

				backgroundColorOpaque = this.data?.backgroundColor || defaultContentBg;
				rgbValuesContentBgOpaque = this.hexToRgb(this.data?.backgroundColor || defaultContentBg);
				hslValuesBgOpaque = this.rgbToHsl(rgbValuesContentBgOpaque);

				primaryTextColor = this.data?.primaryTextColor || defaultTextColor;
				rgbValuesText = this.hexToRgb(this.data?.primaryTextColor || defaultTextColor);
				hslValuesText = this.rgbToHsl(rgbValuesText);

				navBarBgColor = this.hexToRgb(this.data?.navigationBarBgColor || defaultNavBarBgColor);
				navBarTextColor = this.data?.navigationBarTextColor || primaryTextColor;

				navBarButtonColor = this.data?.navigationBarButtonColor || defaultPrimary;
				rgbNavBarButtonColor = this.hexToRgb(this.data?.navigationBarButtonColor || defaultPrimary);
				hslNavBarButtonColor = this.rgbToHsl(rgbNavBarButtonColor);

				navBarButtonTextColor = this.data?.navigationBarButtonTextColor || defaultTextColor;
				rgbBarButtonTextColor = this.hexToRgb(this.data?.navigationBarButtonTextColor || defaultTextColor);
				hslBarButtonTextColor = this.rgbToHsl(rgbBarButtonTextColor);

				buttonAlternativeBackgroundColor = this.data?.buttonAlternativeBackgroundColor || defaultContentBg;
				rgbButtonAlternativeBackgroundColor = this.hexToRgb(
					this.data?.buttonAlternativeBackgroundColor || defaultContentBg
				);
				hslButtonAlternativeBackgroundColor = this.rgbToHsl(rgbBarButtonTextColor);

				buttonAlternativeTextColor = this.data?.buttonAlternativeTextColor || defaultTextColor;
				rgbButtonAlternativeTextColor = this.hexToRgb(
					this.data?.buttonAlternativeTextColor || defaultTextColor
				);
				hslButtonAlternativeBackgroundColor = this.rgbToHsl(rgbBarButtonTextColor);

				detailTextColor = this.data?.detailTextColor || defaultTextColor;
				rgbDetailTextColor = this.hexToRgb(this.data?.detailTextColor || defaultTextColor);
				hslDetailTextColor = this.rgbToHsl(rgbDetailTextColor);

				detailBackgroundColor = this.data?.detailBackgroundColor || defaultTextColor;
				rgbDetailBackgroundColor = this.hexToRgb(this.data?.detailBackgroundColor || defaultTextColor);
				hslDetailBackgroundColor = this.rgbToHsl(rgbDetailBackgroundColor);

				if (this.data.cardBgColor) {
					cardBgColor = this.data.cardBgColor;
				} else {
					cardBgColor = `hsla(${hslValuesBg[0] * 360}, ${hslValuesBg[1] * 100}%, ${hslValuesBg[2] * 125}%,${
						hslValuesBg[3]
					})`;
				}

				if (this.data.navigationTopBarLinks) {
					navigationTopBarLinks = this.data.navigationTopBarLinks;
				}
			}

			// ticket list view
			const ticketHeaderBackgroundColor = this.data?.ticketHeaderBackgroundColor ?? defaultContentBg;
			const ticketHeaderFontColor = this.data?.ticketHeaderFontColor ?? defaultTextColor;
			const ticketItemBackgroundColor = this.data?.ticketItemBackgroundColor ?? defaultContentBg;
			const ticketItemFontColor = this.data?.ticketItemFontColor ?? defaultTextColor;

			// stepper progress bar
			const progressBarBackgroundColor = this.data?.progressBarBackgroundColor ?? defaultContentBg;
			const progressBarFontColor = this.data?.progressBarFontColor ?? defaultTextColor;
			const progressBarActiveBackgroundColor = this.data?.progressBarActiveBackgroundColor ?? defaultPrimary;
			const progressBarActiveFontColor = this.data?.progressBarActiveFontColor ?? defaultTextColor;

			// wishlist bar
			const wishlistBackgroundColor = this.data?.wishlistBackgroundColor ?? defaultWishlistColor;
			const wishlistFontColor = this.data?.wishlistFontColor ?? defaultTextColor;

			document.documentElement.style.setProperty('--wishlist-background-color', wishlistBackgroundColor);
			document.documentElement.style.setProperty('--wishlist-font-color', wishlistFontColor);

			document.documentElement.style.setProperty('--ticket-header-background-color', ticketHeaderBackgroundColor);
			document.documentElement.style.setProperty('--ticket-header-font-color', ticketHeaderFontColor);
			document.documentElement.style.setProperty('--ticket-item-background-color', ticketItemBackgroundColor);
			document.documentElement.style.setProperty('--ticket-item-font-color', ticketItemFontColor);

			document.documentElement.style.setProperty('--progress-bar-background-color', progressBarBackgroundColor);
			document.documentElement.style.setProperty('--progress-bar-font-color', progressBarFontColor);
			document.documentElement.style.setProperty(
				'--progress-bar-active-background-color',
				progressBarActiveBackgroundColor
			);
			document.documentElement.style.setProperty('--progress-bar-active-font-color', progressBarActiveFontColor);

			// To be able to use a color variable in rgba(), it has to be stored not as hex but as RGB (and than it can ONLY be used in a rgba() declaration).
			document.documentElement.style.setProperty('--primary-color', rgbValuesPrimary.join(','));
			document.documentElement.style.setProperty('--primary-body-color', primaryTextColor);

			document.documentElement.style.setProperty('--content-background-rgb', rgbValuesContentBg.join(','));
			document.documentElement.style.setProperty('--content-background', backgroundColor);

			document.documentElement.style.setProperty('--content-background-rgba', rgbValuesContentBgOpaque.join(','));
			document.documentElement.style.setProperty('--content-background-opaque', backgroundColorOpaque);

			document.documentElement.style.setProperty(
				'--content-background-light',
				`hsla(${hslValuesBg[0] * 360}, ${hslValuesBg[1] * 100}%, ${hslValuesBg[2] * 125}%,${hslValuesBg[3]})`
			);

			document.documentElement.style.setProperty('--navbar-bg-color', navBarBgColor);
			document.documentElement.style.setProperty('--navbar-text-color', navBarTextColor);
			document.documentElement.style.setProperty('--navbar-button-color', navBarButtonColor);
			document.documentElement.style.setProperty('--navbar-button-text-color', navBarButtonTextColor);

			document.documentElement.style.setProperty(
				'--button-alternative-background-color',
				rgbButtonAlternativeBackgroundColor
			);
			document.documentElement.style.setProperty('--button-alternative-text-color', buttonAlternativeTextColor);

			document.documentElement.style.setProperty('--detail-text-color', detailTextColor);
			document.documentElement.style.setProperty('--detail-background-color', detailBackgroundColor);

			document.documentElement.style.setProperty('--card-bg-color', cardBgColor);

			document.documentElement.style.setProperty(
				'--primary-body-color-dark',
				`hsla(${hslValuesText[0] * 360}, ${hslValuesText[1] * 100}%, ${hslValuesText[2] * 20}%,${
					hslValuesBg[3]
				})`
			);

			document.documentElement.style.setProperty('--navigation-top-bar-links', navigationTopBarLinks);

			if (this.data.nogrdients !== 'No') {
				// Gradients off
				document.documentElement.style.setProperty('--content-background-light-2', backgroundColor);
				document.documentElement.style.setProperty('--content-background-dark', backgroundColor);
				document.documentElement.style.setProperty('--navbar-button--light', navBarButtonColor);
				document.documentElement.style.setProperty('--navbar-button--dark', navBarButtonColor);
				document.documentElement.style.setProperty(
					'--black-gradient',
					`linear-gradient(${backgroundColor},${backgroundColor})`
				);
				document.documentElement.style.setProperty(
					'--black-gradient--inv',
					`linear-gradient(${backgroundColor},${backgroundColor})`
				);
			} else {
				// Gradients on
				document.documentElement.style.setProperty(
					'--content-background-light-2',
					`hsla(${hslValuesBg[0] * 360}, ${hslValuesBg[1] * 100}%, ${hslValuesBg[2] * 150}%,${
						hslValuesBg[3]
					})`
				);
				document.documentElement.style.setProperty(
					'--content-background-dark',
					`hsla(${hslValuesBg[0] * 360}, ${hslValuesBg[1] * 100}%, ${hslValuesBg[2] * 90}%,${hslValuesBg[3]})`
				);

				document.documentElement.style.setProperty(
					'--navbar-button--dark',
					`hsla(${hslNavBarButtonColor[0] * 360}, ${hslNavBarButtonColor[1] * 100}%, ${
						hslNavBarButtonColor[2] * 70
					}%,${hslValuesBg[3]})`
				);
			}

			this.$nextTick(() => {
				this.isShopColorsSet = true; // So we don't get colors flickering
			});
		}
	}
};
